import client from "api/client";

import { slugify } from "components/content/contentUtils";

// F1 — tagsApi. Website-scoped /websites/{websiteId}/content-tags. Supports
// create-on-the-fly from the content tag picker and a management screen. The
// website comes from the path, so `website_id` is never sent in the body.

// Unpaginated list — used by the content form's TagPicker.
export const listTags = async (websiteId) => {
  const { data } = await client.get(`/websites/${websiteId}/content-tags`);
  return data.items ?? [];
};

// Paginated + searchable list — used by the Tags management screen.
export const listTagsPaged = async (websiteId, { limit = 25, offset = 0, search } = {}) => {
  const params = { limit, offset, sort_by: "name", sort_desc: false };
  if (search) params.search = search;
  const { data } = await client.get(`/websites/${websiteId}/content-tags`, { params });
  return { items: data.items ?? [], total: data.total ?? 0, hasMore: !!data.has_more };
};

export const getTag = async (websiteId, id) => {
  const { data } = await client.get(`/websites/${websiteId}/content-tags/${id}`);
  return data;
};

// createTag requires both name and slug; the slug is derived when not supplied.
export const createTag = async (websiteId, { name, slug }) => {
  const body = { name, slug: slug || slugify(name) };
  const { data } = await client.post(`/websites/${websiteId}/content-tags`, body);
  return data;
};

export const updateTag = async (websiteId, id, payload) => {
  const { data } = await client.put(`/websites/${websiteId}/content-tags/${id}`, payload);
  return data;
};

export const deleteTag = async (websiteId, id) => {
  await client.delete(`/websites/${websiteId}/content-tags/${id}`);
};
